<div class="" *ngIf="formGroupStep1">
  <app-page-header
    [title]="updateEvent ? 'Atualizar evento' : 'Criar evento'"
    [titleIcon]="updateEvent ? 'pi pi-pen-to-square' : 'pi pi-plus'"
    [subtitle]="
      'Preencha as etapas para configurar seu evento e garantir uma experiência incrível para os participantes.'
    "
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Área do produtor', link: '/producer-area', icon: 'pi pi-chart-bar' },
      {
        label: updateEvent ? 'Atualizar evento' : 'Criar evento',
        icon: updateEvent ? 'pi pi-pen-to-square' : 'pi pi-plus',
      },
    ]">
    @if (this.dialogRef) {
      <app-button styleType="clean" (click)="onClose()"><i class="pi pi-times"></i></app-button>
    }
  </app-page-header>
  <div class="p-3 pt-0">
    <div [ngSwitch]="currentStep" class="create-event-multi-form--formStepOne">
      <form [formGroup]="formGroupStep1" class="">
        <div class="card">
          <div class="card-body">
            <div class="mb-3 row">
              <div class="d-flex flex-column">
                <p class="h4 m-0">Informações Básicas do Evento</p>
                <p class="p text-secondary">
                  Dê um nome ao seu evento, escolha uma categoria, descrição e adicione um banner atraente.
                </p>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-8">
                <label for="title" class="form-label">Nome do Evento</label>
                <input
                  pInputText
                  formControlName="title"
                  name="title"
                  type="text"
                  class="form-control"
                  id="title"
                  placeholder="Digite o nome do evento" />
                <small
                  *ngIf="formGroupStep1.get('title')?.invalid && formGroupStep1.get('title')?.touched"
                  class="text-danger">
                  O nome do evento é obrigatório.
                </small>
              </div>

              <div class="col-sm-12 col-md-6 col-lg-4">
                <label for="event_category_id" class="form-label">Categoria</label>
                <select
                  placeholder="Selecione a categoria do evento"
                  formControlName="event_category_id"
                  name="event_category_id"
                  class="form-select form-select"
                  aria-label="Large select example">
                  <option value="" disabled>Selecione uma categoria</option>
                  @for (item of eventCategories; track $index) {
                    <option [value]="item.id">{{ item.title }}</option>
                  }
                </select>
                <small
                  *ngIf="
                    formGroupStep1.get('event_category_id')?.invalid && formGroupStep1.get('event_category_id')?.touched
                  "
                  class="text-danger">
                  A categoria é obrigatória.
                </small>
              </div>
            </div>

            <div class="mb-3">
              <label for="description" class="form-label">Descrição do Evento</label>
              <div class="d-flex flex-column">
                <textarea
                  pTextarea
                  cols="20"
                  rows="5"
                  formControlName="description"
                  name="description"
                  type="text"
                  class="form-control"
                  id="description"
                  [(ngModel)]="formGroupStep1.value.description"
                  placeholder="Digite a descrição do evento"></textarea>
                <!-- <p-editor [(ngModel)]="formGroupStep1.value.description" [style]="{ height: '300px' }"
                  formControlName="description">
                </p-editor> -->

                <small
                  *ngIf="formGroupStep1.get('description')?.invalid && formGroupStep1.get('description')?.touched"
                  class="text-danger">
                  A descrição do evento é obrigatória.
                </small>
              </div>
            </div>
            <form [formGroup]="formGroupStep3">
              <div class="row">
                <label for="uploadBanner" class="form-label">Banner Principal</label>
                <div *ngIf="uploadedImage" class="image-preview">
                  <img [src]="uploadedImage" alt="Uploaded Image" (load)="onImageLoad($event)" />
                </div>
                <div class="input-group p-3" *ngIf="showImageInput">
                  <input
                    formControlName="uploadBanner"
                    name="uploadBanner"
                    type="file"
                    class="form-control"
                    id="uploadBanner"
                    (change)="onFileChange($event)" />
                </div>
                <div *ngIf="!showImageInput" class="p-3">
                  <app-button icon="pi pi-pencil" (click)="showImageInput = true">Alterar imagem</app-button>
                </div>
              </div>
            </form>
            <form [formGroup]="formGroupStep3">
              <div class="row">
                <label for="mapaEvento" class="form-label">Mapa do evento (opcional)</label>
                <div *ngIf="uploadedMapImage" class="image-preview">
                  <img [src]="uploadedMapImage" alt="Uploaded Image" (load)="onImageLoad($event)" />
                </div>
                <div class="input-group p-3" *ngIf="showMapImageInput">
                  <input
                    formControlName="mapaEvento"
                    name="mapaEvento"
                    type="file"
                    class="form-control"
                    id="mapaEvento"
                    (change)="onMapFileChange($event)" />
                </div>
                <div *ngIf="!showMapImageInput" class="p-3">
                  <app-button icon="pi pi-pencil" (click)="showMapImageInput = true">Alterar imagem do mapa</app-button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div formGroupName="eventDateGroup" class="card">
          <div class="row card-body">
            <div class="d-flex flex-column">
              <p class="h4 m-0">Data e horário</p>
              <p class="p text-secondary">
                Escolha quando seu evento começará e terminará para que os participantes possam se programar.
              </p>
            </div>
            <div class="col">
              <div class="mb-3">
                <label for="start_date" class="form-label">Data e Hora de Início</label>
                <div class="input-group">
                  <input
                    formControlName="start_date"
                    type="date"
                    class="form-control"
                    id="start_date"
                    aria-describedby="startDateHelp" />
                  <input
                    formControlName="start_time"
                    type="time"
                    class="form-control"
                    id="start_time"
                    aria-describedby="startTimeHelp" />
                </div>
                <div
                  *ngIf="
                    formGroupStep1.get('eventDateGroup.start_date')?.invalid &&
                    formGroupStep1.get('eventDateGroup.start_date')?.touched
                  "
                  class="text-danger">
                  A data de início é obrigatória.
                </div>
                <div
                  *ngIf="
                    formGroupStep1.get('eventDateGroup.start_time')?.invalid &&
                    formGroupStep1.get('eventDateGroup.start_time')?.touched
                  "
                  class="text-danger">
                  A hora de início é obrigatória.
                </div>
                <div
                  *ngIf="
                    formGroupStep1.get('eventDateGroup')?.errors?.['dateBeforeCurrent'] &&
                    formGroupStep1.get('eventDateGroup')?.touched
                  "
                  class="text-danger">
                  As datas de início e/ou término não podem ser antes da data atual.
                </div>
                <div
                  *ngIf="
                    formGroupStep1.get('eventDateGroup')?.errors?.['datesAreEqual'] &&
                    formGroupStep1.get('eventDateGroup')?.touched
                  "
                  class="text-danger">
                  As datas de início e término não podem ser iguais.
                </div>
              </div>
            </div>

            <div class="col">
              <div class="mb-3">
                <label for="end_date" class="form-label">Data e Hora de Término</label>
                <div class="input-group">
                  <input
                    formControlName="end_date"
                    type="date"
                    class="form-control"
                    id="end_date"
                    aria-describedby="startDateHelp" />
                  <input
                    formControlName="end_time"
                    type="time"
                    class="form-control"
                    id="end_time"
                    aria-describedby="startTimeHelp" />
                </div>
                <div
                  *ngIf="
                    formGroupStep1.get('eventDateGroup.end_date')?.invalid &&
                    formGroupStep1.get('eventDateGroup.end_date')?.touched
                  "
                  class="text-danger">
                  A data de término é obrigatória.
                </div>
                <div
                  *ngIf="
                    formGroupStep1.get('eventDateGroup.end_time')?.invalid &&
                    formGroupStep1.get('eventDateGroup.end_time')?.touched
                  "
                  class="text-danger">
                  A hora de término é obrigatória.
                </div>
                <div
                  *ngIf="
                    formGroupStep1.get('eventDateGroup')?.errors?.['dateEndBeforeStart'] &&
                    formGroupStep1.get('eventDateGroup')?.touched
                  "
                  class="text-danger">
                  A data de término não pode ser antes da data de início.
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- Step 2 -->
      <div *ngIf="isMapLoaded">
        <form [formGroup]="formGroupStep2">
          <div class="card">
            <div class="card-body d-flex flex-column">
              <div class="d-flex flex-column">
                <p class="h4 m-0">Endereço do Evento</p>
                <p class="p text-secondary">
                  Informe o local exato. Pesquise por CEP ou nome da rua para facilitar a localização.
                </p>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-12">
                  <div class="">
                    <label for="zip" class="form-label">CEP</label>
                    <div class="d-flex gap-2">
                      <input
                        formControlName="zip"
                        type="text"
                        class="form-control"
                        id="zip"
                        name="zip"
                        mask="00000-000" />
                      <app-button [disabled]="formGroupStep2.value.zip.length < 8" (click)="searchPostalCode()"
                        >Buscar</app-button
                      >
                    </div>

                    <small
                      *ngIf="formGroupStep2.get('zip')?.invalid && formGroupStep2.get('zip')?.touched"
                      class="text-danger">
                      O CEP é obrigatório.
                    </small>
                  </div>

                  <div class="row mt-2">
                    <div class="col-8 position-relative">
                      <label for="street" class="form-label">Rua</label>
                      <div class="d-flex justify-content-between align-items-center gap-2">
                        <input
                          formControlName="street"
                          type="text"
                          class="form-control"
                          id="street"
                          name="street"
                          (focus)="showSugestions = true" />

                        <div title="Limpar endereço">
                          <app-button
                            (click)="clearAddress()"
                            *ngIf="formGroupStep2.value.street.length > 1"
                            styleType="clean">
                            <i class="pi pi-times align-self-center"></i>
                          </app-button>
                        </div>
                      </div>
                      <div class="container-sugestions" *ngIf="showSugestions">
                        <ul class="list-group">
                          @for (item of addressSugestions; track $index) {
                            <li (click)="setSugestionAsAddress(item)" class="list-group-item">
                              {{ item.formatted_address }}
                            </li>
                          }
                        </ul>
                      </div>
                      <div
                        *ngIf="formGroupStep2.get('street')?.invalid && formGroupStep2.get('street')?.touched"
                        class="text-danger">
                        A rua é obrigatória.
                      </div>
                    </div>
                    <div class="col-4">
                      <label for="number" class="form-label">Número</label>
                      <input formControlName="number" type="number" class="form-control" id="number" name="number" />
                      <div
                        *ngIf="formGroupStep2.get('number')?.invalid && formGroupStep2.get('number')?.touched"
                        class="text-danger">
                        O número é obrigatório.
                      </div>
                    </div>
                  </div>
                  <div class="mt-2">
                    <label for="location_name" class="form-label">Nome do Local</label>
                    <input
                      autocomplete="off"
                      formControlName="location_name"
                      type="text"
                      class="form-control"
                      id="location_name"
                      name="location_name" />
                    <div
                      *ngIf="
                        formGroupStep2.get('location_name')?.invalid && formGroupStep2.get('location_name')?.touched
                      "
                      class="text-danger">
                      O local do evento é obrigatório.
                    </div>
                  </div>
                  <div class="mt-2">
                    <label for="neighborhood" class="form-label">Bairro/Distrito</label>
                    <input
                      formControlName="neighborhood"
                      type="text"
                      class="form-control"
                      id="neighborhood"
                      name="neighborhood" />
                    <div
                      *ngIf="formGroupStep2.get('neighborhood')?.invalid && formGroupStep2.get('neighborhood')?.touched"
                      class="text-danger">
                      O bairro é obrigatório.
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-6">
                      <label for="city" class="form-label">Cidade</label>
                      <input formControlName="city" name="city" type="text" class="form-control" id="city" />
                      <div
                        *ngIf="formGroupStep2.get('city')?.invalid && formGroupStep2.get('city')?.touched"
                        class="text-danger">
                        A cidade é obrigatória.
                      </div>
                    </div>
                    <div class="col-6">
                      <label for="state" class="form-label">UF</label>
                      <select
                        formControlName="state"
                        name="state"
                        class="form-select"
                        [disabled]="true"
                        aria-label="Large select example">
                        @for (item of eventLocationState; track $index) {
                          <option [value]="item.abbr">{{ item.name }}</option>
                        }
                      </select>
                      <div
                        *ngIf="formGroupStep2.get('state')?.invalid && formGroupStep2.get('state')?.touched"
                        class="text-danger">
                        O UF é obrigatório.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-12">
                  <div class="col-12 mt-3">
                    <label for="map" class="form-label">Mapa do Evento</label>
                    <google-map height="300px" width="100%" [center]="center" [zoom]="15">
                      <map-marker [position]="center"></map-marker>
                    </google-map>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div *ngIf="!isMapLoaded">
        <p>Carregando mapa...</p>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-column">
            <p class="h4 m-0">Tipo de evento</p>
            <p class="p text-secondary">Escolha uma opção para definir se o evento será pago ou gratuito.</p>
          </div>
          <div class="gap-3 d-flex align-items-start justify-content-evenly flex-wrap row">
            <div class="d-flex flex-column align-items-center p-2 gap-2 col-lg-5 col-md-6">
              <app-button
                [styleType]="paidEvent ? 'primary' : 'outlined'"
                (click)="handleChangeEventType(true)"
                icon="pi pi-dollar"
                >EVENTO PAGO</app-button
              >
              <p class="p text-secondary text-center" [ngClass]="{ 'fw-bold text-dark': paidEvent }">
                Escolha esta opção se desejar vender ingressos para o evento. Note que ingressos gratuitos podem ser
                adicionados posteriormente nos detalhes do evento.
              </p>
            </div>
            <div class="d-flex flex-column align-items-center p-2 gap-2 col-lg-5 col-md-6">
              <app-button
                styleType="outlined"
                (click)="handleChangeEventType(false)"
                icon="pi pi-gift"
                [styleType]="!paidEvent ? 'primary' : 'outlined'"
                >EVENTO GRATUITO</app-button
              >
              <p class="p text-secondary text-center" [ngClass]="{ 'fw-bold text-dark': !paidEvent }">
                Escolha esta opção se todos os ingressos do evento forem gratuitos.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex flex-column">
              <p class="h4 m-0">Ingressos do Tipo Individual</p>
              <p class="p text-secondary">Configure ingressos e visualize suas opções criadas na tabela abaixo.</p>
            </div>
          </div>
          <app-ticket-table
            [openModalTickets]="openModalTickets"
            [handleEditTicket]="editTicket"
            [management]="updateEvent && !!eventInfo.id"
            [transitionDisabledReason]="transitionDisabledReason"
            (batchesTransitioned)="onBatchTransitioned($event)"
            (ticketBatchesChange)="handleTicketBatchChange($event)"
            [(ticketBatches)]="ticketBatches"></app-ticket-table>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="">
            <p class="h4 m-0">Revise as Informações do Evento</p>
            <p class="p text-secondary">
              Confira todos os detalhes antes de concluir. Certifique-se de que tudo está correto para o sucesso do seu
              evento.
            </p>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" [ngClass]="{ 'list-group-item-success': formGroupStep1.value.title }">
              <div class="d-flex justify-content-start align-items-center gap-3">
                <div>
                  <p class="h6 alert-heading d-flex align-items-center gap-2">
                    Nome
                    <i class="pi pi-check" *ngIf="formGroupStep1.value.title"></i>
                  </p>
                  <p class="p text-secondary">
                    {{ formGroupStep1.get("title")?.value ? formGroupStep1.get("title")?.value : "Não informado" }}
                  </p>
                </div>
              </div>
            </li>
            <li
              class="list-group-item"
              [ngClass]="{ 'list-group-item-success': formGroupStep1.value.event_category_id }">
              <div class="d-flex justify-content-start align-items-center gap-3">
                <div>
                  <p class="h6 alert-heading d-flex align-items-center gap-2">
                    Categoria
                    <i class="pi pi-check" *ngIf="formGroupStep1.value.event_category_id"></i>
                  </p>
                  <p class="p text-secondary">
                    {{
                      formGroupStep1.get("event_category_id")?.value
                        ? getEventCategoryName(formGroupStep1.get("event_category_id")?.value)
                        : "Não informado"
                    }}
                  </p>
                </div>
              </div>
            </li>
            <li class="list-group-item" [ngClass]="{ 'list-group-item-success': uploadedImage }">
              <div class="d-flex justify-content-start align-items-center gap-3">
                <div>
                  <p class="h6 alert-heading d-flex align-items-center gap-2">
                    Banner Principal
                    <i class="pi pi-check" *ngIf="uploadedImage"></i>
                  </p>
                  <div class="image-preview">
                    <img [src]="uploadedImage" alt="Imagem não informada" (load)="onImageLoad($event)" />
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item" [ngClass]="{ 'list-group-item-success': formGroupStep1.value.description }">
              <div class="d-flex justify-content-start align-items-center gap-3">
                <div>
                  <p class="h6 alert-heading d-flex align-items-center gap-2">
                    Descrição
                    <i class="pi pi-check" *ngIf="formGroupStep1.value.description"></i>
                  </p>
                  <div
                    class=""
                    [innerHTML]="
                      formGroupStep1.get('description')?.value
                        ? formGroupStep1.get('description')?.value
                        : 'Não informado'
                    "></div>
                </div>
              </div>
            </li>
            <li
              class="list-group-item"
              [ngClass]="{ 'list-group-item-success': formGroupStep2.value.street && formGroupStep2.value.number }">
              <div class="d-flex justify-content-start align-items-center gap-3">
                <div>
                  <p class="h6 alert-heading d-flex align-items-center gap-2">
                    Endereço do evento
                    <i class="pi pi-check" *ngIf="formGroupStep2.value.street && formGroupStep2.value.number"></i>
                  </p>
                  <p class="p text-secondary">
                    @if (formGroupStep2.value.street && formGroupStep2.value.number) {
                      {{ formatAddressView() }}
                    } @else {
                      Não informado
                    }
                  </p>
                </div>
              </div>
            </li>
            <li
              class="list-group-item"
              [ngClass]="{ 'list-group-item-success': formGroupStep1.value.eventDateGroup.start_date }">
              <div class="d-flex justify-content-start align-items-center gap-3">
                <div>
                  <p class="h6 alert-heading d-flex align-items-center gap-2">
                    Data e hora de início do evento
                    <i class="pi pi-check" *ngIf="formGroupStep1.value.eventDateGroup.start_date"></i>
                  </p>
                  <p class="p text-secondary">
                    {{
                      formGroupStep1.get("eventDateGroup.start_date")?.value +
                        " " +
                        formGroupStep1.get("eventDateGroup.start_time")?.value
                    }}
                  </p>
                </div>
              </div>
            </li>
            <li
              class="list-group-item"
              [ngClass]="{ 'list-group-item-success': formGroupStep1.value.eventDateGroup.end_date }">
              <div class="d-flex justify-content-start align-items-center gap-3">
                <div>
                  <p class="h6 alert-heading d-flex align-items-center gap-2">
                    Data e hora de término do evento
                    <i class="pi pi-check" *ngIf="formGroupStep1.value.eventDateGroup.end_date"></i>
                  </p>
                  <p class="p text-secondary">
                    {{
                      formGroupStep1.get("eventDateGroup.end_date")?.value +
                        " " +
                        formGroupStep1.get("eventDateGroup.end_time")?.value
                    }}
                  </p>
                </div>
              </div>
            </li>
            <li class="list-group-item" [ngClass]="{ 'list-group-item-success': ticketBatches.length > 0 }">
              <div>
                <p class="h6 alert-heading d-flex align-items-center gap-2">
                  Resumo dos ingressos
                  <i class="pi pi-check" *ngIf="ticketBatches.length > 0"></i>
                </p>
                <div class="d-flex flex-column gap-3">
                  @for (batch of ticketBatches; track batch; let i = $index) {
                    <app-batch-summary [batch]="batch" [batchIndex]="i"
                      [management]="updateEvent && !!eventInfo.id" [transitionDisabledReason]="transitionDisabledReason"
                      (batchesChanged)="onBatchTransitioned($event)"></app-batch-summary>
                  }
                </div>
                <p class="p text-secondary" *ngIf="ticketBatches.length == 0">Sem ingressos criados</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container-errors">
      @for (item of getFormValidationErrors(); track $index) {
        <div class="alert alert-danger" role="alert">
          {{ item }}
        </div>
      }
    </div>
    @if (submitErrors.length > 0) {
      <div class="container-errors">
        @for (submitError of submitErrors; track submitError) {
          <div class="alert alert-danger" role="alert">
            {{ submitError }}
          </div>
        }
      </div>
    }

    <div class="">
      <form [formGroup]="formGroupStep1" class="">
        <div class="card-body p-0">
          <div class="col-12 mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="accepted_terms" id="accepted_terms" />
              <label class="form-check-label" for="accepted_terms">
                Eu li e aceito os <a href="/terms-of-use" target="_blank">termos e condições</a> do site.
              </label>
            </div>
            <small
              *ngIf="formGroupStep1.get('accepted_terms')?.invalid && formGroupStep1.get('accepted_terms')?.touched"
              class="text-danger">
              Você precisa aceitar os termos e condições para continuar.
            </small>
          </div>
          @if (updateEvent) {
            <div class="alert alert-warning d-flex align-items-center gap-3 rounded" role="alert">
              <i class="pi pi-exclamation-triangle alert-icon" aria-hidden="true"></i>
              <p class="alert-content">
                <strong>Atenção:</strong> Ao salvar estas alterações, todos os compradores serão automaticamente
                notificados e poderão solicitar reembolso, conforme nossos
                <a href="/terms-of-use" target="_blank" class="alert-link"
                  >termos de uso<span class="sr-only">(abre em nova janela)</span></a
                >.
              </p>
            </div>
          }
          <div class="row d-flex gap-3 justify-content-between">
            <div class="col-sm-12 col-md-4 col-lg-2">
              <label for="status" class="form-label">Status do evento</label>
              <select
                placeholder="Selecione o status do evento"
                formControlName="status"
                name="status"
                class="form-select form-select"
                aria-label="Large select example">
                <option value="published">Publicado</option>
                <option value="draft">Rascunho</option>
                <!-- <option value="cancelled">Cancelado</option> -->
              </select>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-3">
              <label for="status" class="form-label">Visibilidade do evento</label>
              <div class="d-flex justify-content-between align-items-center gap-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="is_private"
                    id="flexRadioDefault1"
                    [value]="false" />
                  <label class="form-check-label" for="flexRadioDefault1"> Público </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="is_private"
                    id="flexRadioDefault2"
                    [value]="true" />
                  <label class="form-check-label" for="flexRadioDefault2"> Privado </label>
                </div>
              </div>
            </div>
            <div
              class="col-sm-12 col-md-4 col-lg-4 d-flex align-items-center justify-content-end"
              [ngClass]="{ 'justify-content-between': this.dialogRef }">
              @if (this.dialogRef) {
                <app-button styleType="secondary" (click)="onClose()">Cancelar</app-button>
              }

              <app-button
                (click)="submitForm()"
                [disabled]="!formGroupStep1.valid || !formGroupStep2.valid || !formGroupStep3.valid">
                {{ updateEvent ? "Atualizar evento" : "Criar evento" }}
              </app-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
